export default __webpack_public_path__ + "static/media/information--lane-control-multiple-lanes--g2.c56d8bde.png";